import { render, staticRenderFns } from "./video-index.vue?vue&type=template&id=158d5906&scoped=true"
import script from "./video-index.vue?vue&type=script&lang=js"
export * from "./video-index.vue?vue&type=script&lang=js"
import style0 from "./video-index.vue?vue&type=style&index=0&id=158d5906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158d5906",
  null
  
)

export default component.exports